import Picture from '../picture'

interface Props {
  heading: string
  icon: string
  description: string
}

const MobileSolutionItem = ({ heading, icon, description }: Props) => (
  <section className="mt-6 flex mb-2.5">
    <Picture
      image={icon}
      imageAlt={heading}
      aria-hidden="true"
      role="presentation"
      imageStyle="mr-4 mt-1 w-14 h-14"
    />
    <article className="flex-1">
      <p className="font-medium font-natosans-medium text-[#101010] text-xl leading-[1.36]">
        {heading}
      </p>
      <p className="font-light font-natosans-light text-lg leading-[1.56]">
        {description}
      </p>
    </article>
  </section>
)

export default MobileSolutionItem
